import * as React from 'react';

import { useDispatch } from 'react-redux';
import { resetRegFlow } from '../actions/registrationActions';
import { navigateTop } from '../routing/router-utils';
import zipRunLogo from '../../assets/ZipRunLogoSm.png';
import Helmet from 'react-helmet'; 
import SuppressNav from '../layout/SuppressNav';
import GreenPageBody from '../layout/GreenPageBody';
import PropTypes from 'prop-types';

import styles from './Registration.module.css';

/** 
 *  Basic header with Logo and back link for the reg flow
 * 
 *  Flush reg flow data on navigation 
 **/
const RegFlowHeader = ({
  pageTitle,
  backLink
}) => {
  
  const dispatch = useDispatch();

  // const slideInHelp = () => {
  //  alert('We could slide in some help content'); 
  // };
  
  const backLinkClick = (link) => {
    // Handle back to WWW / marketing site
    if ( window.document.referrer?.indexOf('framableLocationSearch') > -1 ) {
      window.history.go(-2);
    } else {
      navigateTop(link);
    }  
  };

  const headerLogoClick = () => {
    dispatch(resetRegFlow());
    navigateTop('/');
  };    

  return (
    <div className={styles.regFlowHeader}>
      { pageTitle && 
        <Helmet>
          <title>Zip Run - {pageTitle}</title>  
        </Helmet>
      }
      <SuppressNav />
      <GreenPageBody />
      { backLink
        ? <span className={styles.backLink} onClick={() => backLinkClick(backLink)}>
            &larr;
          </span> 
        : null
      }
      
      <span className={styles.regFlowlogoLink} onClick={() => headerLogoClick()}>
        <img alt="logo" className={styles.regFlowlogo} src={zipRunLogo} />
      </span> 

      {/* TODO: help page content ? */}
      {/*
      <span className={styles.regFlowHelp} onClick={slideInHelp}>
        ?
      </span>
      */}
    </div>
  );
};

RegFlowHeader.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  backLink:  PropTypes.string
}

export default RegFlowHeader;